import { render } from "./page-agenthome.vue?vue&type=template&id=65480ef6"
import script from "./page-agenthome.js?vue&type=script&lang=js"
export * from "./page-agenthome.js?vue&type=script&lang=js"

import "./page-agenthome.vue?vue&type=style&index=0&id=65480ef6&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__